import React from 'react';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box } from '@mui/material';
import { EmptyState, PageHeader, PagePaper } from 'dashboard/components/common';

/**
 * Short-term placeholder for brand-side pages that haven't been built
 * out yet. Used by routes that need an element but whose feature ships
 * later.
 */
function Placeholder({ title, subtitle }) {
  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <PagePaper>
        <PageHeader title={title} subtitle={subtitle} />
        <EmptyState>This page is part of an upcoming feature.</EmptyState>
      </PagePaper>
    </Box>
  );
}

export const AccountBilling = () => (
  <Placeholder title='Billing' subtitle='Subscription and invoice history for this brand.' />
);
export const AccountInvoice = () => (
  <Placeholder title='Invoice manager' subtitle='Legacy invoice tooling.' />
);
export const MarketingPlaceholder = () => (
  <Placeholder title='Marketing' subtitle='Campaign tooling lives here.' />
);
